/**
 * 表格「序号」跨页连续：(当前页 − 1) × 每页条数 + 行号 + 1，第 2 页每页 20 条时从 21 开始。
 * 自动找离表格最近的 el-pagination 取页码和每页条数；没有分页时从 1 开始。
 * 用法：<template slot-scope="scope">{{ $pageIndex(scope) }}</template>
 */
// 弹窗 / 抽屉是独立区域：找到这一层还没有就不再往外找，避免借用外层主列表的页码
var BOUNDARY = ['el-dialog__body', 'el-drawer__body'];
function findPagination(tableEl) {
  var el = tableEl && tableEl.parentElement;
  while (el) {
    var list = el.querySelectorAll('.el-pagination');
    for (var i = 0; i < list.length; i++) {
      // 跳过隐藏的分页（比如没激活的标签页里的）
      if (list[i].__vue__ && list[i].offsetParent !== null) return list[i].__vue__;
    }
    if (el.classList && BOUNDARY.some(function (c) {
      return el.classList.contains(c);
    })) return null;
    el = el.parentElement;
  }
  return null;
}
export default function pageIndex(scope) {
  var table = scope.store && scope.store.table;
  var p = table && table.$el ? findPagination(table.$el) : null;
  var page = p && p.internalCurrentPage || 1;
  var size = p && p.internalPageSize || 0;
  return (page - 1) * size + scope.$index + 1;
}